<div class="card-slider">
    <ng-template #loaderTemplateEl>
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 cards-slick-loader-template">
            <div class="cards-slick-loader-template-cubes-wrapper">
                <div class="cards-slick-loader-template-cube app-loader-blink"></div>
                <div class="cards-slick-loader-template-cube app-loader-blink"></div>
                <div class="cards-slick-loader-template-cube app-loader-blink"></div>
                <div class="cards-slick-loader-template-cube app-loader-blink"></div>
            </div>
        </div>
    </ng-template>
    <ng-container *ngIf="cards; else loaderTemplateEl">
        <ngx-slick-carousel
            [ngClass]="{
                'triple-cards': cards.length == 3,
                'one-card': cards.length == 1,
                'two-cards': cards.length == 2,
                'many-cards': cards.length > 4
            }"
            [config]="slideConfig"
            #slickModal="slick-carousel"
            class="card-slide center slider"
        >
            <div
                *ngFor="let card of cards; let i = index"
                ngxSlickItem
                class="card"
                [id]="'SourceCard' + i"
                (click)="selectCard(card)"
            >
                <div class="" class="image-container" [ngClass]="{ 'pick-card': card == CardSelectedRef }">
                    <img [id]="'imgCarousel' + i" [src]="card.cardImage" alt="" class="card-img" />
                </div>
                <div class="card-info">
                    <span class="ellipsis-two-line">{{ card.shortCardNumber }} {{ card.cardName }}</span>
                    <span>{{ card.destinationBenefitDesc }}</span>
                </div>
            </div>
        </ngx-slick-carousel>
    </ng-container>
</div>
